// --- ExtractionDistributionCard data ---

export const DEMO_EXTRACTION_PREVIOUS = [
  { name: 'Extraits', value: 320 },
  { name: 'Entiers', value: 180 }
];

export const DEMO_EXTRACTION_CURRENT = [
  { name: 'Extraits', value: 410 },
  { name: 'Entiers', value: 140 }
];

// --- SourceTypeDistributionCard data ---

export const DEMO_SOURCE_TYPE_PREVIOUS = [
  { name: 'Web', value: 180 },
  { name: 'Print', value: 120 },
  { name: 'Social', value: 60 },
  { name: 'TV/Radio', value: 40 }
];

export const DEMO_SOURCE_TYPE_CURRENT = [
  { name: 'Web', value: 220 },
  { name: 'Print', value: 100 },
  { name: 'Social', value: 95 },
  { name: 'TV/Radio', value: 35 }
];

// --- TimeseriesCard data ---

export const DEMO_TIMESERIES = [
  { date: '2025-07', 'Client A': 28, 'Concurrent 1': 22 },
  { date: '2025-08', 'Client A': 35, 'Concurrent 1': 24 },
  { date: '2025-09', 'Client A': 42, 'Concurrent 1': 30 },
  { date: '2025-10', 'Client A': 38, 'Concurrent 1': 27 },
  { date: '2025-11', 'Client A': 45, 'Concurrent 1': 33 },
  { date: '2025-12', 'Client A': 50, 'Concurrent 1': 28 },
  { date: '2026-01', 'Client A': 48, 'Concurrent 1': 35 },
  { date: '2026-02', 'Client A': 55, 'Concurrent 1': 38 },
  { date: '2026-03', 'Client A': 60, 'Concurrent 1': 40 },
  { date: '2026-04', 'Client A': 52, 'Concurrent 1': 36 },
  { date: '2026-05', 'Client A': 58, 'Concurrent 1': 42 },
  { date: '2026-06', 'Client A': 65, 'Concurrent 1': 45 }
];

// --- CompetitorComparisonCard data ---

export const DEMO_COMPETITOR_COMPARISON = [
  { name: 'Client A', Articles: 120, Sources: 45 },
  { name: 'Concurrent 1', Articles: 95, Sources: 38 },
  { name: 'Concurrent 2', Articles: 78, Sources: 32 },
  { name: 'Concurrent 3', Articles: 65, Sources: 28 }
];

// --- YearOverYearCard data ---

export const DEMO_YOY_ARTICLES = [
  { client: 'Client A', '2025': 95, '2026': 120 },
  { client: 'Concurrent 1', '2025': 80, '2026': 95 },
  { client: 'Concurrent 2', '2025': 60, '2026': 78 }
];

export const DEMO_YOY_SOURCES = [
  { client: 'Client A', '2025': 35, '2026': 45 },
  { client: 'Concurrent 1', '2025': 30, '2026': 38 },
  { client: 'Concurrent 2', '2025': 25, '2026': 32 }
];

export const DEMO_YOY_GROWTH = [
  { label: 'Client A', articleGrowth: 26.3, sourceGrowth: 28.6 },
  { label: 'Concurrent 1', articleGrowth: 18.8, sourceGrowth: 26.7 },
  { label: 'Concurrent 2', articleGrowth: 30.0, sourceGrowth: 28.0 }
];

// --- CountryDistributionCard data ---

export const DEMO_COUNTRY_DISTRIBUTION = [
  { country: 'France', 'Client Articles': 45, 'Concurrent Moyenne': 30 },
  { country: 'USA', 'Client Articles': 32, 'Concurrent Moyenne': 28 },
  { country: 'UK', 'Client Articles': 28, 'Concurrent Moyenne': 22 },
  { country: 'Germany', 'Client Articles': 20, 'Concurrent Moyenne': 18 },
  { country: 'Italy', 'Client Articles': 18, 'Concurrent Moyenne': 25 },
  { country: 'Japan', 'Client Articles': 15, 'Concurrent Moyenne': 12 },
  { country: 'China', 'Client Articles': 12, 'Concurrent Moyenne': 20 },
  { country: 'Belgium', 'Client Articles': 10, 'Concurrent Moyenne': 8 }
];

// --- OpponentCountryCard data ---

export const DEMO_OPPONENTS = [
  {
    name: 'Concurrent 1',
    countries: [
      { country: 'France', client: 45, opponent: 38, diff: 7 },
      { country: 'USA', client: 32, opponent: 35, diff: -3 },
      { country: 'UK', client: 28, opponent: 20, diff: 8 },
      { country: 'Germany', client: 20, opponent: 22, diff: -2 },
      { country: 'Italy', client: 18, opponent: 30, diff: -12 }
    ]
  },
  {
    name: 'Concurrent 2',
    countries: [
      { country: 'France', client: 45, opponent: 25, diff: 20 },
      { country: 'USA', client: 32, opponent: 40, diff: -8 },
      { country: 'UK', client: 28, opponent: 15, diff: 13 },
      { country: 'Germany', client: 20, opponent: 12, diff: 8 },
      { country: 'Italy', client: 18, opponent: 14, diff: 4 }
    ]
  }
];
